const layout = {
  font: {
    family: "Libre Franklin,sans-serif",
  },
  title: {
    font: {
      family: 'Georgia',
      size: 20,
      color: '#000',
    },
    text: "Stakeholdergruppen",
    x: "3",
    y: "auto",
  },

  showlegend: true,
  legend: {
    y: 0.5,
    orientation: "v",
    xanchor: "left",
    yanchor: "bottom",
    itemclick: false,
  },

  // width: 900,

  xaxis: {
    type: "linear",

    range: {
      0: -0.05,
      1: 10.01,
    },
    tick0: 0,
    dtick: 5,
    title: {
      font: {
        size: 20,
        color: '#2a3f5f',
      },
      text: "Interesse",
    },

    tickmode: "linear",
    showspikes: true,
    showticklabels: true,
    spikethickness: 6,
    tickfont: {
      color: 'rgb(168, 74, 74)',
      size: 18,
    },
    visible: true,
    color: '#444',
    tickangle: "auto",
    anchor: "y",
    side: "bottom",
  },

  yaxis: {
    type: "linear",
    range: {
      0: -0.05,
      1: 10.05,
    },
    title: {
      font: {
        size: 20,
        color: '#2a3f5f',
      },
      text: "Einfluss",
    },
    tick0: 0,
    dtick: 5,
    tickfont: {
      color: 'rgb(168, 74, 74)',
      size: 18,
    },
    visible: true,
    color: '#444',

    showticklabels: true,
    tickangle: "auto",
    anchor: "x",
    side: "left",
  },

  // height: 600,

  margin: {
    b: 65,
    l: 65,
    r: 65,
    t: 65,
    pad: 0,
    autoexpand: true,
  },

  annotations: [
    {
      visible: true,
      clicktoshow: false,
      opacity: 1,
      bgcolor: 'rgba(22,0,0,0)',
      bordercolor: 'rgba(22,0,0,0)',
      borderpad: 0,
      borderwidth: 0,
      showarrow: false,
      name: '',
      text: '',
      textangle: 0,
      font: {
        size: 16,
        color: 'rgb(133, 129, 129)',
      },
      align: "left",
      xref: "x",
      x: 0.6,
      xanchor: "auto",
      xshift: 0,
      yref: "y",
      y: 0,
      yanchor: "top",
      yshift: 0,
    },
    {
      name: '',
      visible: true,
      clicktoshow: false,
      opacity: 1,
      bgcolor: 'rgba(22,0,0,0)',
      bordercolor: 'rgba(22,0,0,0)',
      borderpad: 0,
      borderwidth: 0,
      showarrow: false,
      text: '',
      textangle: 0,
      font: {
        size: 16,
        color: 'rgb(133, 129, 129)',
      },
      align: "center",
      xref: "x",
      x: 9.6,
      xanchor: "center",
      xshift: 0,
      yref: "y",
      y: 0,
      yanchor: "top",
      yshift: 0,
    },
    {
      name: '',
      visible: true,
      clicktoshow: false,
      opacity: 1,
      bgcolor: 'rgba(22,0,0,0)',
      bordercolor: 'rgba(22,0,0,0)',
      borderpad: 0,
      borderwidth: 0,
      showarrow: false,
      text: '',
      textangle: -90,
      font: {
        size: 16,
        color: 'rgb(133, 129, 129)',
      },
      align: "left",
      xref: "x",
      x: 0,
      xanchor: "right",
      xshift: 0,
      yref: "y",
      y: 0.9,
      yanchor: "auto",
      yshift: 0,
    },
    {
      name: '',
      visible: true,
      clicktoshow: false,
      opacity: 1,
      bgcolor: 'rgba(22,0,0,0)',
      bordercolor: 'rgba(22,0,0,0)',
      borderpad: 0,
      borderwidth: 0,
      showarrow: false,
      text: '',
      textangle: -90,
      font: {
        size: 16,
        color: 'rgb(133, 129, 129)',
      },
      align: "center",
      xref: "x",
      x: 0,
      xanchor: "right",
      xshift: 0,
      yref: "y",
      y: 9.4,
      yanchor: "auto",
      yshift: 0,
    },
    {
      name: "right-bottom",
      visible: true,
      clicktoshow: false,
      opacity: 1,
      bgcolor: 'rgba(0, 0, 0, 0)',
      bordercolor: 'rgba(0, 0, 0, 0)',
      borderpad: 1,
      borderwidth: 1,
      showarrow: false,
      text: "",
      textangle: 0,
      font: {
        size: 14,
        color: '#2a3f5f',
      },
      align: "right",
      captureevents: false,
      xref: "x",
      x: 9.9,
      xanchor: "right",
      xshift: 0,
      yref: "y",
      y: 0.5,
      yanchor: "auto",
      yshift: 0,
    },
    {
      name: "left-bottom",
      visible: true,
      clicktoshow: false,
      opacity: 1,
      bgcolor: 'rgba(0, 0, 0, 0)',
      bordercolor: 'rgba(0, 0, 0, 0)',
      borderpad: 1,
      borderwidth: 1,
      showarrow: false,
      text: "",
      textangle: 0,
      font: {
        size: 14,
        color: '#2a3f5f',
      },
      align: "left",
      captureevents: false,
      xref: "x",
      x: 0.1,
      xanchor: "left",
      xshift: 0,
      yref: "y",
      y: 0.5,
      yanchor: "auto",
      yshift: 0,
    },
    {
      name: "left-top",
      visible: true,
      clicktoshow: false,
      opacity: 1,
      bgcolor: 'rgba(0, 0, 0, 0)',
      bordercolor: 'rgba(0, 0, 0, 0)',
      borderpad: 1,
      borderwidth: 1,
      showarrow: false,
      text: "",
      textangle: 0,
      font: {
        size: 14,
        color: '#2a3f5f',
      },
      align: "left",
      captureevents: false,
      xref: "x",
      x: 0.1,
      xanchor: "left",
      xshift: 0,
      yref: "y",
      y: 10,
      yanchor: "bottom",
      yshift: 0,
    },
    {
      name: "right-top",
      visible: true,
      clicktoshow: false,
      opacity: 1,
      bgcolor: 'rgba(0, 0, 0, 0)',
      bordercolor: 'rgba(0, 0, 0, 0)',
      borderpad: 1,
      borderwidth: 1,
      showarrow: false,
      text: "",
      textangle: 0,
      font: {
        size: 14,
        color: '#2a3f5f',
      },
      align: "right",
      captureevents: false,
      xref: "x",
      x: 9.9,
      xanchor: "right",
      xshift: 0,
      yref: "y",
      y: 10,
      yanchor: "bottom",
      yshift: 0,
    },
  ],
}

export default layout
